import React from 'react';

import { usePreloadDynamicIconImages } from '~src/root/hooks/PreloadDynamicIconImages';
import { useSetPreviousUrlHandler } from '~src/root/hooks/SetPreviousUrl';

import { useDismissModalsHandler } from './DismissModalsHook';

/**
 * This container is a functional wrapper to allow calling hooks. It must be rendered under a router to get access
 * to react-router contexts
 */
export function RouterHooksContainer(props: React.PropsWithChildren<{}>): JSX.Element {
  usePreloadDynamicIconImages();
  useSetPreviousUrlHandler();
  useDismissModalsHandler();
  return <>{props.children}</>;
}
